import { render, staticRenderFns } from "./BalancesPlanDetailsEdit.vue?vue&type=template&id=1ad1a084&scoped=true&"
import script from "./BalancesPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1a084",
  null
  
)

export default component.exports